import { mountPage } from "../shared/app";
import { Login } from "../pages/login";
mountPage(Login);
